import {
  fetchCRM,
  resendImage,
  sendSteps,
  updateSteps,
} from "@/services/register.service";

export default {
  namespaced: true,
  state: {
    // STEPS
    stepID: {},
    // STATUS
    stepsStatus: "init",
    doctor: null,
  },
  getters: {
    // CATEGORIES
    getStepID(state) {
      return state.stepID;
    },
    // STATUS
    getStepStatus(state) {
      return state.stepsStatus;
    },
    getDoctor(state) {
      return state.doctor;
    },
  },
  mutations: {
    // CATEGORIES
    SET_STEP_ID(state, value) {
      state.stepID = value;
    },
    // STATUS
    REGISTER_STATUS(state, value) {
      state.stepsStatus = value;
    },
    REGISTER_DOCTOR(state, value) {
      state.doctor = value;
    },
  },
  actions: {
    // CATEGORIES
    async saveNewStep({ commit }, params) {
      commit("REGISTER_STATUS", "pending");
      try {
        console.log(params);
        const data = await sendSteps(params);
        commit("REGISTER_STATUS", "init");
        //commit('SET_STEP_ID', data.item.id);
        return data;
      } catch (error) {
        commit("REGISTER_STATUS", "init");
        throw error;
      }
    },
    async updateNewStep({ commit }, params) {
      commit("REGISTER_STATUS", "pending");
      try {
        console.log(params);
        const data = await updateSteps(params);
        commit("REGISTER_STATUS", "init");
        //commit('SET_STEP_ID', data.item.id);
        return data;
      } catch (error) {
        commit("REGISTER_STATUS", "init");
        throw error;
      }
    },
    async updateImage({ commit }, params) {
      commit("REGISTER_STATUS", "pending");
      try {
        console.log(params);
        const data = await resendImage(params);
        commit("REGISTER_STATUS", "init");
        //commit('SET_STEP_ID', data.item.id);
        return data;
      } catch (error) {
        commit("REGISTER_STATUS", "init");
        throw error;
      }
    },
    async searchCRM({ commit }, params) {
      commit("REGISTER_STATUS", "pending");
      try {
        const { data } = await fetchCRM(params);
        commit("REGISTER_STATUS", "init");
        commit("REGISTER_DOCTOR", data.doctor);
        return data;
      } catch (error) {
        commit("REGISTER_STATUS", "init");
        throw error;
      }
    },
  },
};
